import { type ReactNode } from 'react';
import { Trash2 } from 'lucide-react';

type Props = {
  isPublished: boolean;
  pending: boolean;
  isEdit: boolean;
  onSaveDraft: () => void;
  onPublish: () => void;
  onDelete?: (() => void) | undefined;
};

const PRIMARY =
  'rounded-md bg-brand-red px-md py-sm text-sm font-medium text-white transition-colors hover:bg-brand-coral disabled:cursor-not-allowed disabled:opacity-50';
const GHOST =
  'rounded-md border border-white/[0.06] px-md py-sm text-sm text-text-secondary transition-colors hover:text-text-primary disabled:cursor-not-allowed disabled:opacity-50';
const DANGER =
  'inline-flex items-center gap-xs rounded-md px-md py-sm text-sm text-error transition-colors hover:bg-error/10 disabled:cursor-not-allowed disabled:opacity-50';
const BAR =
  'sticky bottom-0 -mx-md flex items-center justify-between gap-sm border-t border-white/[0.06] bg-surface/85 px-md py-sm backdrop-blur-md sm:-mx-lg sm:px-lg';

function publishLabel(isEdit: boolean, isPublished: boolean): string {
  if (!isEdit) return 'Publicar';
  return isPublished ? 'Actualizar' : 'Publicar';
}

function SaveButtons(p: Props): ReactNode {
  return (
    <div className="flex items-center gap-sm">
      <button onClick={p.onSaveDraft} disabled={p.pending} className={GHOST}>
        {p.pending ? 'Guardando…' : 'Guardar borrador'}
      </button>
      <button onClick={p.onPublish} disabled={p.pending} className={PRIMARY}>
        {publishLabel(p.isEdit, p.isPublished)}
      </button>
    </div>
  );
}

function DeleteSlot(
  p: Pick<Props, 'isEdit' | 'pending' | 'onDelete'>
): ReactNode {
  if (!p.isEdit || !p.onDelete) return <span />;
  return (
    <button onClick={p.onDelete} disabled={p.pending} className={DANGER}>
      <Trash2 size={14} /> Eliminar
    </button>
  );
}

export function ComposerActions(p: Props): ReactNode {
  return (
    <div className={BAR}>
      <DeleteSlot isEdit={p.isEdit} pending={p.pending} onDelete={p.onDelete} />
      <SaveButtons {...p} />
    </div>
  );
}
